module.exports = __webpack_public_path__ + "img/ContactBG.b9358212.png";